import React, { ReactElement } from 'react'
import { NextPageWithLayout } from '../_app'
import Image from 'next/image'
import { useRouter } from 'next/router'
import HeroBackground from '../../public/static/intro_hero_icon.png'
import { useSession } from 'next-auth/react'
import { SessionStatusEnum } from '../../common/enums/session-status.enum'
import { getActiveApplication } from '../../api/applications/applications'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import {
  applicationsCreatorFormUrl,
  applicationsPendingUrl,
} from '../../common/urls/applications'
import { DefaultSeo } from 'next-seo'
import SEO from '../../next-seo.config'
import Discord from '../../public/static/discord.svg'
import { useRecoilState } from 'recoil'
import { isOpenSignUpModalState } from '../../common/atoms/checkout'
import Layout from '../../components/layout'

const IntroPage: NextPageWithLayout = () => {
  const { t } = useTranslation('applications')
  const router = useRouter()
  const { data: session, status } = useSession()
  const [, setIsOpenSignUp] = useRecoilState(isOpenSignUpModalState)
  async function onClickApplyInviteOnly() {
    // @ts-ignore
    const application = await getActiveApplication(session?.accessToken)

    if (application && application.application == null) {
      router.push(applicationsCreatorFormUrl)
    } else {
      router.push(applicationsPendingUrl)
    }
  }

  return (
    <>
      <DefaultSeo
        {...SEO}
        title={'Apply as Teammate'}
        description={
          'Make money while gaming with the TapIn. Enhance your skills, collaborate with your team, and tackle challenging levels. Apply and become a teammate today!'
        }
      />
      <div className={'relative w-full h-screen mb-48'}>
        <div
          className={
            'absolute top-0 left-0 intro-radial-gradient w-2/3 h-screen z-10'
          }
        />

        <div className='absolute top-0 left-1/2 -translate-x-1/2 flex flex-col md:flex-row items-center justify-center container mx-auto h-full z-20 gap-12 px-5 md:px-0'>
          <div className='w-full md:w-1/2'>
            {/*<div className={'mb-6'}>*/}
            {/*  <Diablo4ApplicationBanner />*/}
            {/*</div>*/}

            <h1 className='text-4xl font-normal font-fjalla text-white mx-auto w-full text-start'>
              {t('introPageTitle')}
            </h1>

            <p className='text-xl-normal text-white mt-6 text-start '>
              {t('introPageDescription')}
            </p>

            <div className='mt-6 flex w-full'>
              {status === SessionStatusEnum.AUTHENTICATED ? (
                <button
                  className='btn-v2-primary w-full'
                  onClick={onClickApplyInviteOnly}
                >
                  {t('appleToBetaButtonTitle')}
                </button>
              ) : (
                <button
                  className='btn-v2-primary w-full'
                  onClick={(e) => {
                    e.preventDefault()
                    setIsOpenSignUp(true)
                  }}
                >
                  {t('appleToBetaButtonTitle')}
                </button>
              )}
            </div>

            <div
              className='btn-v2-white mt-2 flex w-full'
              onClick={(e) => {
                e.preventDefault()
                router.push('https://discord.gg/tapingg')
              }}
            >
              <span className={'mr-4'}>
                <Image
                  src={Discord}
                  height={24}
                  width={24}
                  alt={'Discord icon'}
                />
              </span>
              Join Discord For More Details
            </div>
          </div>

          <div
            className={'w-full md:w-1/2 order-first md:order-1 mt-10 md:mt-0'}
          >
            <Image
              src={HeroBackground}
              width={584}
              height={695}
              className={'object-contain'}
              alt={'Background image'}
            />
          </div>
        </div>
      </div>
    </>
  )
}

IntroPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

type Props = {
  locale: string
}

export async function getStaticProps({ locale }: Props) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'applications'])),
    },
  }
}

export default IntroPage
